<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
    <b-card v-else>
      <template v-slot:header>
        <h5>Detail Order Lelang</h5>
      </template>
      <div class="detail-data-wrapper mb-4">
        <h6 class="form-title">DATA LELANG</h6>
        <b-row class="mb-2">
          <b-col cols="4" class="detail-data-label">Jenis</b-col>
          <b-col>
            {{ dataLelang.jenis.replace(/,/g, ", ") }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="4" class="detail-data-label">Jarak Skema Jasa Dibelakang</b-col>
          <b-col> {{ dataLelang.jarakSkema1 }} Hari </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="4" class="detail-data-label">Jarak Skema Jasa Didepan</b-col>
          <b-col> {{ dataLelang.jarakSkema2 }} Hari </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="4" class="detail-data-label">Tanggal Pembuatan</b-col>
          <b-col>
            {{ $helper.changeDateFormat(dataLelang.createdAt) }}
            {{ $helper.changeDateFormatGetHour(dataLelang.createdAt) }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="4" class="detail-data-label">Tanggal Set Kirim</b-col>
          <b-col>
            {{ $helper.changeDateFormat(dataLelang.tanggalSetKirim) }}
            {{ $helper.changeDateFormatGetHour(dataLelang.tanggalSetKirim) }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="4" class="detail-data-label">Tanggal Planning Set Kirim</b-col>
          <b-col>
            <!-- {{dataLelang.scheduleSetSend}} -->
            {{ $helper.changeDateFormat(dataLelang.scheduleSetSend) }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="4" class="detail-data-label">Status</b-col>
          <b-col>{{ dataLelang.status }}</b-col>
        </b-row>
      </div>
      <div class="detail-data-wrapper mb-4">
        <h6 class="form-title">DATA BARANG</h6>
        <div class="d-flex search-wrapper align-items-center justify-content-between">
          <b-form-group
            label="Filter"
            label-for="filterInput"
            class="form-inline form-group-wrapper mb-3"
          >
            <div class="d-flex align-items-center search-input-wrapper">
              <b-form-group class="ml-2 mr-2">
                <multiselect
                  name="dariCabang"
                  v-model="input.filterCabangBatch"
                  :options="cabangOption"
                  :internal-search="true"
                  :allow-empty="false"
                  deselect-label=""
                  select-label=""
                  label="name"
                  track-by="name"
                  placeholder="Cabang"
                />
              </b-form-group>
              <b-button
                class="mr-2"
                variant="pgiBtn"
                name="searchTableBtn"
                :disabled="isBusy"
                @click="onFilter"
              >
                <i class="fa fa-search"></i>
              </b-button>
              <b-button
                variant="pgiBtn"
                name="resetTableBtn"
                :disabled="isBusy"
                @click="onReset"
                >Reset</b-button
              >
            </div>
          </b-form-group>
        </div>
        <b-table
          bordered
          hover
          show-empty
          :busy="isBusy"
          :items="dataBatchLelangItems"
          :fields="fields"
          :no-local-sorting="false"
          @sort-changed="sortingChanged"
          responsive
          class="mb-3"
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong> Loading data...</strong>
            </div>
          </template>
          <template v-slot:empty> Tidak ada item untuk dicek. </template>
          <template v-slot:cell(jumlahUnit)="row">
            <div class="text-right no-wrap" v-if="row.item.jumlahUnit !== null">
              {{ row.item.jumlahUnit }}
            </div>
            <div class="text-right no-wrap" v-else>-</div>
          </template>
          <template v-slot:cell(jumlahApproved)="row">
            <div class="text-right no-wrap" v-if="row.item.jumlahApproved !== null">
              {{ row.item.jumlahApproved }}
            </div>
            <div class="text-right no-wrap" v-else>-</div>
          </template>
          <template v-slot:cell(jumlahHilang)="row">
            <div class="text-right no-wrap" v-if="row.item.jumlahHilang !== null">
              {{ row.item.jumlahHilang }}
            </div>
            <div class="text-right no-wrap" v-else>-</div>
          </template>
          <template v-slot:cell(action)="row">
            <div class="no-wrap">
              <b-link :to="`${$route.path}/${row.item.id}`">
                <b-button
                  size="sm"
                  class="table-button view"
                  v-b-tooltip.hover
                  title="Detail"
                  name="orderLelangDetailBatchBtn"
                >
                  <i class="fa fa-info"></i>
                </b-button>
              </b-link>
            </div>
          </template>
        </b-table>
        <div class="pagination-wrapper d-flex align-items-center justify-content-between">
          <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
            <b-form-select
              v-model="input.show"
              id="showItems"
              @change="onLimitChange"
              :options="options"
            >
              <template v-slot:first>
                <b-form-select-option :value="null" disabled />
              </template>
            </b-form-select>
            <span class="ml-2">{{ totalViewText }}</span>
          </b-input-group>
          <b-pagination
            class="mb-0"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
            @input="onPageChange"
          ></b-pagination>
        </div>
      </div>
      <div class="form-wrapper-btn" v-if="dataLelang.status == 'PENDING'">
        <b-button name="cancelOrderLelang" variant="danger" @click="openConfirmCancel"
          >Batalkan</b-button
        >
      </div>
      <div class="form-wrapper-btn">
        <b-button
          class="mr-2 mt-2"
          v-if="dataLelang.status == 'ORDER'"
          name="kirimOrderLelang"
          variant="pgiBtn"
          @click="openConfirmKirim"
          >Set Kirim</b-button
        >
        <b-button
          class="mr-2 mt-2"
          v-if="dataLelang.status == 'ORDER' || dataLelang.status == 'TERKIRIM'"
          name="downloadOrderLelang"
          variant="pgiBtn"
          @click="openConfirmDownloadSKElekt"
          >Download Excel SK Elektronik</b-button
        >
        <b-button
          class="mr-2 mt-2"
          v-if="dataLelang.status == 'ORDER' || dataLelang.status == 'TERKIRIM'"
          name="downloadOrderLelang"
          variant="pgiBtn"
          @click="openConfirmDownloadSKEmas"
          >Download Excel SK Emas</b-button
        >
        <b-button
        class="mt-2 mr-2"
          name="downloadOrderLelang"
          variant="dark"
          @click="openConfirmDownloadBarcode"
          >Download Barcode Lelangan Emas</b-button
        >
      </div>
      <div class="form-wrapper-btn">
      <b-button
        class="mr-2 mt-2"
        name="requestDownloadExcelSKElektronik"
        variant="warning"
        @click="openConfirmModal('elektronik')"
      >
        Request Download Excel SK Elektronik
      </b-button>

      <b-button
      class="mt-2"
        name="requestDownloadExcelSKEmas"
        variant="warning"
        @click="openConfirmModal('emas')"
      >
        Request Download Excel SK Emas
      </b-button>
      </div>
    </b-card>
    <ModalConfirm
      id="modal-confirm-cancel"
      title="Confirm Batalkan Order Lelang"
      :isSubmitting="isSubmitting"
      desc="Apakah anda yakin untuk membatalkan Order Lelang ini?"
      @submit="onCancel()"
    />
    <ModalConfirm
      id="modal-confirm-kirim"
      title="Confirm Kirim Order Lelang"
      :isSubmitting="isSubmitting"
      desc="Apakah anda yakin untuk mengirimkan Order Lelang ini?"
      @submit="onSendOrder()"
    />
    <ModalConfirm
      id="modal-confirm-download-SKElekt"
      title="Confirm Download Excel SK Elektronik"
      :isSubmitting="isSubmitting"
      desc="Apakah anda yakin untuk mendownload Excel SK Elektronik ini?"
      @submit="onDownloadSKElekt()"
    />
    <ModalConfirm
      id="modal-confirm-download-SKEmas"
      title="Confirm Download Excel SK Emas"
      :isSubmitting="isSubmitting"
      desc="Apakah anda yakin untuk mendownload Excel SK Emas ini?"
      @submit="onDownloadSKEmas()"
    />
    <ModalConfirm
      id="modal-confirm-download-barcode"
      title="Confirm Download Barcode Lelang Emas"
      :isSubmitting="isSubmitting"
      desc="Apakah anda yakin untuk mendownload Barcode Lelang Emas ini?"
      @submit="onDownloadBarcode()"
    />
    <b-modal
      id="confirm-download-modal"
      v-model="isModalVisible"
      title="Konfirmasi Download"
      @ok="handleConfirm"
      ok-title="Ya, Lanjutkan"
      cancel-title="Batal"
    >
      <p>Apakah Anda yakin ingin request download Excel SK <strong>{{ tipeSK }}</strong>?</p>
    </b-modal>
    <b-modal
      id="modal-download-SKElekt"
      centered
      title="Download Excel SK Elektronik"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center" v-if="isLoadLink == true">
        <b-spinner class="align-middle mb-4"></b-spinner>
        <p class="mb-0">Sedang memproses, mohon menunggu...</p>
      </div>
      <div class="show-btn-download" v-else>
        <p class="">Silakan download dengan klik tombol dibawah ini :</p>
        <b-button variant="pgiBtn" class="mb-0 download-btn">
          <a v-bind:href="$baseFilePath + filePathDownload" download>
            <i class="fa fa-download mr-2"></i>
            Download Batch Lelang
          </a>
        </b-button>
      </div>
    </b-modal>
    <b-modal
      id="modal-download-SKEmas"
      centered
      title="Download Excel SK Emas"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center" v-if="isLoadLink == true">
        <b-spinner class="align-middle mb-4"></b-spinner>
        <p class="mb-0">Sedang memproses, mohon menunggu...</p>
      </div>
      <div class="show-btn-download" v-else>
        <p class="">Silakan download dengan klik tombol dibawah ini :</p>
        <b-button variant="pgiBtn" class="mb-0 download-btn">
          <a v-bind:href="$baseFilePath + filePathDownload" download>
            <i class="fa fa-download mr-2"></i>
            Download Batch Lelang
          </a>
        </b-button>
      </div>
    </b-modal>
    <b-modal
      id="modal-download-barcode"
      centered
      title="Download Barcode Lelang Emas"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center" v-if="isLoadLink == true">
        <b-spinner class="align-middle mb-4"></b-spinner>
        <p class="mb-0">Sedang memproses, mohon menunggu...</p>
      </div>
      <div class="show-btn-download" v-else>
        <p class="">Silakan download dengan klik tombol dibawah ini :</p>
        <b-button variant="pgiBtn" class="mb-0 download-btn">
          <a v-bind:href="$baseFilePath + filePathDownload" target="_blank" download>
            <i class="fa fa-download mr-2"></i>
            Download Barcode Lelang Emas
          </a>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "detail-order-lelang",
  data() {
    return {
      id: null,
      isBusy: true,
      isSubmitting: false,
      initStatus: 1,
      input: {
        show: 10,
        filterCabangBatch: null,
        sortBy: null,
        sortDesc: null,
      },
      fields: [
        { key: "cabang", label: "Cabang" },
        { key: "jumlahUnit", label: "Jumlah Unit" },
        { key: "jumlahApproved", label: "Jumlah Approved" },
        { key: "jumlahHilang", label: "Jumlah Hilang" },
        { key: "action", label: "Aksi" },
      ],
      options: [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 30, text: "30" },
        { value: 40, text: "40" },
        { value: 50, text: "50" },
      ],
      cabangOption: [],
      dataLelang: {},
      dataBatchLelangItems: [],
      currentPage: 1,
      perPage: 10,
      rows: null,
      totalViewText: "",
      page: "",
      size: "",
      filtering: false,
      query: "",
      isLoadLink: false,
      filePathDownload: "",
      isModalVisible: false,
      tipeSK: '', 
    };
  },
  methods: {
    //----------------- Fungsi Inisialisasi -----------------

    init() {
      this.initStatus = 0;

      this.id = this.$route.params.id;

      this.page = 0;
      this.size = this.input.show;
      this.query = this.$helper.makeQuery(this.page, this.size);
      this.query = this.query + "&orderId=" + this.id;

      let getCabang = this.$axios.get("cabang/all-selection").then((response) => {
        response.data.forEach((element) => {
          if (element.id != this.srcCabangId) this.cabangOption.push(element);
        });
      });

      let getSingleDataLelang = this.$axios
        .get(`lelang-order/${this.id}`)
        .then((response) => {
          this.dataLelang = response.data;
          this.toggleBusy();
          let msg = this.$helper.getFlash();
          this.$helper.toastSucc(this, msg);
        });

      let getBatchLelangItems = this.$axios
        .get(`lelang-order/batch/${this.query}`)
        .then((response) => {
          this.dataBatchLelangItems = response.data.data;
          this.updateTotalItem(response.data.total);

          let msg = this.$helper.getFlash();
          this.$helper.toastSucc(this, msg);
        });

      Promise.all([getCabang, getSingleDataLelang, getBatchLelangItems])
        .then(() => {
          this.initStatus = 1;
        })
        .catch(() => {
          this.initStatus = -1;
        });
    },

    //----------------- Fungsi Ambil Data Cek Items -----------------

    getBatchLelangItems() {
      if (this.isBusy == false) this.isBusy = true;
      this.page = this.currentPage - 1;
      this.dataBatchLelangItems = [];

      if (this.filtering == false) {
        this.query = this.$helper.makeQuery(this.page, this.size);
      }

      this.query = this.query + "&orderId=" + this.id;
      this.$axios
        .get(`lelang-order/batch/${this.query}`)
        .then((response) => {
          this.dataBatchLelangItems = response.data.data;
          this.toggleBusy();
          this.updateTotalItem(response.data.total);
          this.filtering = false;
        })
        .catch((error) => {
          this.$helper.parseError(this, error);
          this.toggleBusy();
          this.filtering = false;
        });
    },

    //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------

    onLimitChange() {
      this.toggleBusy();
      this.size = this.input.show;
      this.perPage = this.input.show;
      this.currentPage = 1;
      this.getBatchLelangItems();
    },

    onPageChange() {
      if (this.filtering == false) {
        this.toggleBusy();
        this.getBatchLelangItems();
      }
    },

    sortingChanged(ctx) {
      if (ctx.sortBy != "") {
        this.input.sortBy = ctx.sortBy;
        this.input.sortDesc = ctx.sortDesc;
        this.currentPage = 1;
        this.getBatchLelangItems();
      }
    },

    onReset() {
      this.input.filterCabangBatch = null;
      this.currentPage = 1;
      this.toggleBusy();
      this.getBatchLelangItems();
    },

    onFilter() {
      this.toggleBusy();
      this.currentPage = 1;
      this.query = this.$helper.makeQuery(0, this.size);

      if (this.input.filterCabangBatch != null)
        this.query = this.query + "&filterCabang=" + this.input.filterCabangBatch.id;
      if (this.input.sortBy != null)
        this.query = this.query + "&sortBy=" + this.input.sortBy;
      if (this.input.sortDesc != null)
        this.query = this.query + "&sortDesc=" + this.input.sortDesc;

      this.filtering = true;
      this.getBatchLelangItems();
    },

    updateTotalItem(total) {
      let limit = null;
      let prevLimit = null;
      this.perPage = this.size;
      this.rows = total;
      prevLimit = this.page * this.size + 1;
      limit = this.page * this.size + this.size;
      if (limit > this.rows) limit = this.rows;
      this.totalViewText =
        "Menampilkan " + prevLimit + " - " + limit + " dari " + this.rows + " entri";
    },

    //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

    toggleBusy() {
      if (this.isBusy == true) this.isBusy = false;
      else this.isBusy = true;
    },

    openConfirmCancel() {
      this.$bvModal.show("modal-confirm-cancel");
    },

    openConfirmKirim() {
      this.$bvModal.show("modal-confirm-kirim");
    },

    openConfirmDownloadSKElekt() {
      this.$bvModal.show("modal-confirm-download-SKElekt");
    },

    openConfirmDownloadSKEmas() {
      this.$bvModal.show("modal-confirm-download-SKEmas");
    },

    openConfirmDownloadBarcode() {
      this.$bvModal.show("modal-confirm-download-barcode");
    },

    onCancel() {
      let payload = new FormData();

      //----------------- Append Data Cancel -----------------

      payload.append("lelangOrderId", this.id);

      //----------------- Submit Semua Data -----------------

      this.isSubmitting = true;

      this.$axios
        .post("lelang-order/cancel/", payload)
        .then(() => {
          this.$helper.setFlash(`Order Lelang telah berhasil dibatalkan!`);
          let path = this.$route.path.split("/");
          path.pop();
          path = path.join("/");
          this.$router.push({ path });
        })
        .catch((error) => {
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },

    onSendOrder() {
      let payload = new FormData();

      //----------------- Append Data Order -----------------

      payload.append("lelangOrderId", this.id);

      //----------------- Submit Semua Data -----------------

      this.isSubmitting = true;

      this.$axios
        .post("lelang-order/set-kirim/", payload)
        .then(() => {
          this.$helper.setFlash(`Order Lelang telah berhasil dikirim!`);
          let path = this.$route.path.split("/");
          path.pop();
          path = path.join("/");
          this.$router.push({ path });
        })
        .catch((error) => {
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },

    onDownloadSKElekt() {
      this.isLoadLink = true;
      this.$bvModal.show("modal-download-SKElekt");
      this.$bvModal.hide("modal-confirm-download-SKElekt");
      setTimeout(() => {
        this.axiosDownloadSKElekt();
      }, 500);
    },

    onDownloadSKEmas() {
      this.isLoadLink = true;
      this.$bvModal.show("modal-download-SKEmas");
      this.$bvModal.hide("modal-confirm-download-SKEmas");
      setTimeout(() => {
        this.axiosDownloadSKEmas();
      }, 500);
    },

    onDownloadBarcode() {
      this.isLoadLink = true;
      this.$bvModal.show("modal-download-barcode");
      this.$bvModal.hide("modal-confirm-download-barcode");
      setTimeout(() => {
        this.axiosDownloadBarcode();
      }, 500);
    },

    axiosDownloadSKElekt() {
      this.$axios
        .get(`lelang-order/cetak-excel-set-kirim?lelangOrderId=${this.id}`, {
          timeout: 1200000,
        })
        .then((response) => {
          this.filePathDownload = response.data;
        })
        .catch((error) => {
          if (error.response) {
            this.$helper.parseError(this, error);
          } else if (error.code === "ECONNABORTED") {
          }
        })
        .finally(() => {
          this.isLoadLink = false;
        });
    },

    axiosDownloadSKEmas() {
      this.$axios
        .get(`lelang-order/cetak-excel-set-kirim-emas?lelangOrderId=${this.id}`, {
          timeout: 1200000,
        })
        .then((response) => {
          this.filePathDownload = response.data;
        })
        .catch((error) => {
          if (error.response) {
            this.$helper.parseError(this, error);
          } else if (error.code === "ECONNABORTED") {
          }
        })
        .finally(() => {
          this.isLoadLink = false;
        });
    },

    axiosDownloadBarcode() {
      this.$axios
        .get(`lelang-order/cetak-barcode-lelangan-emas?lelangOrderId=${this.id}`)
        .then((response) => {
          this.filePathDownload = response.data.name;
        })
        .catch((error) => {
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isLoadLink = false;
        });
    },
    openConfirmModal(tipe) {
      this.tipeSK = tipe
      this.isModalVisible = true
    },
    async handleConfirm() {
      try {
        let url = ''

        if (this.tipeSK === 'elektronik') {
          url = `/request-laporan/cetak-excel-set-kirim-elek?lelangOrderId=${this.id}`
        } else if (this.tipeSK === 'emas') {
          url = `/request-laporan/cetak-excel-set-kirim-emas?lelangOrderId=${this.id}`
        }

        await this.$axios.get(url)
        this.$bvToast.toast('Berhasil mengirim request download.', {
          title: 'Sukses',
          variant: 'success',
          solid: true,
        })
      } catch (error) {
        this.$bvToast.toast('Gagal request download.', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      }
    },

  },

  created() {
    this.init();
  },
};
</script>
